import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="policy-page">
      <Header />
      <div className="policy-container">
        <h1 className="policy-title">Privacy Policy</h1>
        <p className="policy-date">Last updated: April 2026</p>

        <div className="policy-content">
          <section className="policy-section">
            <h3 className="section-title">1. Introduction</h3>
            <p className="section-text">
              Liiskerlane ("we," "us," "our," or "Company") is committed to
              protecting your privacy. This Privacy Policy explains how we
              collect, use, disclose, and otherwise handle your information when
              you visit our website, use our services, or interact with us in
              other ways.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">2. Information We Collect</h3>
            <p className="section-text">
              We collect information you provide directly to us, such as:
            </p>
            <ul className="section-list">
              <li>Name, email address, and contact information</li>
              <li>Billing and shipping address</li>
              <li>
                Payment information (processed securely through third-party
                providers)
              </li>
              <li>Account preferences and settings</li>
              <li>Communications and feedback you send us</li>
              <li>Information about your pet (optional)</li>
            </ul>
            <p className="section-text">
              We also automatically collect certain information about your
              device and how you interact with our website, including IP
              address, browser type, operating system, referring URLs, and pages
              visited.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">3. How We Use Your Information</h3>
            <p className="section-text">
              We use the information we collect to:
            </p>
            <ul className="section-list">
              <li>Process and fulfill your orders</li>
              <li>
                Send transactional communications (order confirmations, shipping
                updates)
              </li>
              <li>Provide customer support and respond to inquiries</li>
              <li>Improve our website and services</li>
              <li>Send marketing communications (with your consent)</li>
              <li>Detect and prevent fraud or security issues</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="policy-section">
            <h3 className="section-title">4. Information Sharing</h3>
            <p className="section-text">
              We do not sell, trade, or rent your personal information to third
              parties. We may share information with:
            </p>
            <ul className="section-list">
              <li>
                Service providers who assist us in operating our website and
                conducting our business
              </li>
              <li>Payment processors to process your transactions</li>
              <li>Shipping partners to deliver your orders</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </section>

          <section className="policy-section">
            <h3 className="section-title">5. Data Security</h3>
            <p className="section-text">
              We implement appropriate technical and organizational measures to
              protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. However, no method of
              transmission over the internet is 100% secure.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">6. Cookies and Tracking</h3>
            <p className="section-text">
              Our website uses cookies to enhance your experience. Cookies are
              small files stored on your device that help us remember your
              preferences and track website usage. You can control cookie
              settings through your browser.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">7. Your Rights</h3>
            <p className="section-text">
              Depending on your location, you may have the right to:
            </p>
            <ul className="section-list">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt-out of marketing communications</li>
              <li>Request a copy of your information</li>
            </ul>
          </section>

          <section className="policy-section">
            <h3 className="section-title">8. Third-Party Links</h3>
            <p className="section-text">
              Our website may contain links to third-party websites. We are not
              responsible for the privacy practices of these external sites.
              Please review their privacy policies before providing any
              information.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">9. Children's Privacy</h3>
            <p className="section-text">
              Our website is not intended for children under 13 years of age. We
              do not knowingly collect personal information from children. If we
              become aware that a child has provided us with personal
              information, we will take steps to delete such information.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">10. Contact Us</h3>
            <p className="section-text">
              If you have questions about this Privacy Policy or our privacy
              practices, please contact us at:
            </p>
            <div className="contact-info">
              <p>
                <strong>Email:</strong> trade@liiskerlane.digital
              </p>
              <p>
                <strong>Mailing Address:</strong> Liiskerlane, 19 Bridport Ave,
                Singapore 559309
              </p>
            </div>
          </section>

          <section className="policy-section">
            <h3 className="section-title">11. Changes to This Policy</h3>
            <p className="section-text">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new policy on this page
              and updating the "Last updated" date above.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
